export enum EGender {
	Man = "1",
	Woman = "2"
}